import { render, staticRenderFns } from "./UpdateDialog.vue?vue&type=template&id=1df5d7a0&scoped=true"
import script from "./UpdateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateDialog.vue?vue&type=style&index=0&id=1df5d7a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df5d7a0",
  null
  
)

export default component.exports